import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { firebaseStorage } from '../../../utils/firebase';
import styles from './styles';

class FirebaseImage extends React.Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    slide: PropTypes.bool,
  };

  state = {
    loading: true,
    src: "/images/loading.gif",
  };

  componentWillMount() {
    firebaseStorage.ref(this.props.src)
      .getDownloadURL()
      .then((src) => {
        this.setState({
          src,
          loading: false,
        });
      }
      );
  }

  render() {
    if (this.state.loading) {
      return (this.props.slide ? <img src="/images/loading.gif" style={styles.loading} alt="img" /> :
      <img src={this.state.src} {..._.omit(this.props, ['src', 'slide'])} alt="img" />);
    }

    return (
      this.props.slide ?
        <img src={this.state.src} {..._.omit(this.props, ['src', 'slide', 'onImageLoad', 'key'])} alt="img" /> :
        <img src={this.state.src} style={{ height: this.props.height, width: this.props.width ? this.props.width : 'auto' }} alt="img" />

    );
  }
}

export default FirebaseImage;



// WEBPACK FOOTER //
// ./src/components/Common/FirebaseImage/index.js